import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlowOperatorContext, KioskLayoutOption } from '../types/kiosk-flow-types';
import { assertOperator } from './flow-validation';

export class GetKioskLayoutsUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  async execute(ctx: KioskFlowOperatorContext): Promise<KioskLayoutOption[]> {
    assertOperator(ctx);
    return this.repository.getLayouts(ctx);
  }
}
